import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { Images } from "@/constants/images"
import { toNFC } from "@/lib/string-helper"
import type { TimeLine } from "@/types/tour"
import Image from "next/image"

const TimeLineSection = ({
  timeLine,
  value,
  setValue,
}: {
  timeLine?: TimeLine[]
  value?: string[]
  setValue?: (value: string[]) => void
}) => {
  if (!timeLine || timeLine.length === 0) return null
  return (
    <div className="lg:w-full">
      <Accordion type="multiple" className="flex flex-col gap-6" value={value} onValueChange={setValue}>
        {timeLine.map((item, index) => (
          <AccordionItem key={index} value={index?.toString()} className="flex flex-row gap-2 w-full border-none">
            <div className="flex flex-col gap-2">
              <div className="relative w-6 h-6">
                <Image
                  src={Images.locationTimeLine}
                  alt={`${item?.time} - ${item?.checkpoint}`}
                  width={24}
                  height={24}
                  sizes="80vw"
                  className="object-contain"
                />
              </div>

              {index !== timeLine.length - 1 && (
                <div className="relative min-w-6 flex h-full justify-center">
                  <div className="border-r border-dashed border-[#999999]" />
                </div>
              )}

              {index == timeLine.length - 1 && value?.includes(index?.toString()) && (
                <div className="relative min-w-6 flex h-full justify-center">
                  <div className="border-r border-dashed border-[#999999]" />
                </div>
              )}
            </div>

            <div className={`w-full ${index === timeLine.length - 1 ? "" : "border-b"}`}>
              <AccordionTrigger
                className="no-underline hover:no-underline pb-6 pt-0 w-full"
                customStyleIcon={{ className: "w-5 h-5" }}
              >
                <div className="flex flex-row group">
                  <p className="text-xl lg:text-2xl font-medium text-[#4F4F4F] lg:uppercase text-wrap group-hover:text-[#3ab54b] transition-all duration-200 max-w-24 w-full lg:max-w-none lg:w-fit lg:text-nowrap">
                    {item?.time}
                  </p>

                  <p className="text-xl leading-[1.875rem] font-semibold text-[#242F3E] pl-4 break-words lg:pl-2 group-hover:text-[#3ab54b] transition-all duration-200">
                    {item?.checkpoint}
                  </p>
                </div>
              </AccordionTrigger>

              <AccordionContent>
                <div className="flex flex-col gap-8 pb-2 pr-6">
                  <p
                    className="font-normal text-base leading-[1.6875rem] text-[#000000]"
                    dangerouslySetInnerHTML={{ __html: toNFC(item?.description).replace(/\n/g, "<br />") }}
                  />

                  {item?.facility && item?.facility?.length > 0 && (
                    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-2">
                      {item?.facility?.map(facility => (
                        <div key={facility?.id} className="flex flex-row gap-2 items-center">
                          {facility?.icon_facility && facility?.icon_facility !== "" && (
                            <Image
                              src={Images[facility?.icon_facility as keyof typeof Images]}
                              alt={facility?.description ?? ""}
                              width={32}
                              height={32}
                              sizes="80vw"
                              className="object-contain w-8 h-8"
                            />
                          )}

                          <p className="text-base leading-[1.6875rem] text-[#4F4F4F] font-normal">
                            {facility?.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </AccordionContent>
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default TimeLineSection
